import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { selectVehicle } from '../../../Vehicles/selectors';
import { selectWork } from '../../../Api/selectors';
import { Card } from '../../../../components/Card';
import { REQUEST_VEHICLE } from '../../../Vehicles/constants';
import { fetchVehicle } from '../../../Vehicles/actions';
import { DocumentsList } from '../../../Documents/components/documentsList';
import { Loader } from '../../../../components/Loader';

const Container = styled.div`
  font-size: 14px;
  h3 {
    font-size: 20px;
  }
  .type {
    color: #6c757d;
  }
  .regplate {
  }

  .status-label {
    width: fit-content;
  }
`;

const STATE = {
  email: false,
};
/* eslint-disable react/prefer-stateless-function */
class VehicleDocumentCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    !this.props.isFetched && this.props.fetch();
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get invoicePurchaseDoc() {
    return this.vehicle?.documents?.filter(doc => doc?.originalFilename == 'invoice_purchase');
  }

  render() {
    const invoice = this.props.invoice;

    if (this.props.work) return <Loader small />;

    return (
      <Card className="vehicle-info-card info-card info">
        <Container width={window.innerWidth}>
          {!this.invoicePurchaseDoc?.length && <p>{this.lbl('incoming.document.notfound')}</p>}
          <DocumentsList
            invoiceDetails
            entityId={this.vehicle?.id}
            entityType="vehicle"
            items={this.invoicePurchaseDoc}
            vehicle={this.props.vehicle}
          ></DocumentsList>
        </Container>
      </Card>
    );
  }
}

VehicleDocumentCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    vehicle: selectVehicle(ownProps.vehicleId),
    work: selectWork(REQUEST_VEHICLE),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchVehicle(ownProps?.vehicleId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleDocumentCard = compose(withConnect, withRouter)(VehicleDocumentCardComp);
